
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

interface StoreItem {
  id: number;
  image: string;
  name: string;
}

@Component
export default class StoresScroller extends Vue {
  @Prop({ required: true, type: Array }) readonly stores!: StoreItem[];

  get isDesktop(): boolean {
    return window.innerWidth >= 768;
  }

  scrollLeft(): void {
    const container = this.$refs.scrollContainer as HTMLElement;
    container.scrollBy({ left: -200, behavior: "smooth" });
  }

  scrollRight(): void {
    const container = this.$refs.scrollContainer as HTMLElement;
    container.scrollBy({ left: 200, behavior: "smooth" });
  }

  goToStores() {
    this.$router.push("Lojas");
  }

  goToStore(storeId: number) {
    this.$emit("go-to-store", storeId);
  }
}
